import { render, staticRenderFns } from "./CarteBoissonsView.vue?vue&type=template&id=a382d938"
import script from "./CarteBoissonsView.vue?vue&type=script&lang=js"
export * from "./CarteBoissonsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports